/**
 * Background-video sound on/off button.
 *
 * Loaded once by `snippets/section.liquid` for any section whose background
 * video has the "Show sound on/off button" setting enabled. Behaviour is
 * delegated from `document` so a single instance handles every such section
 * and keeps working after Section Rendering API re-renders.
 *
 * The video starts muted+autoplay (required by browsers). The first click is a
 * user gesture, so unmuting/playing with sound is allowed.
 */
(() => {
  if (window.__videoSoundToggleInit) return;
  window.__videoSoundToggleInit = true;

  const LABEL_ON = 'Turn sound off'; // shown while sound is playing
  const LABEL_OFF = 'Turn sound on'; // shown while muted

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-video-sound-toggle]');
    if (!button) return;

    const section = button.closest('.section');
    const video = section?.querySelector('video-background-component video');
    if (!video) return;

    // Currently muted -> the click turns sound ON (and vice versa).
    const turningOn = video.muted;
    video.muted = !turningOn;

    if (turningOn) {
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }
    }

    const soundOn = !video.muted;
    const label = button.querySelector('.video-sound-toggle__label');
    if (label) label.textContent = soundOn ? LABEL_ON : LABEL_OFF;
    button.setAttribute('aria-pressed', String(soundOn));
    button.classList.toggle('is-on', soundOn);
  });
})();
